import { normalizeSuggestionKeywords } from "@/components/suggestions/providers/utils/normalizeKeywords";
import { GroupNodeModel } from "@/models/nodes/GroupNodeModel";
import { VariableNodeModel } from "@/models/nodes/VariableNodeModel";

import type { SingleSuggestion, SuggestionProvider } from "@/components/suggestions/types";

export const variableArgumentsSuggestionsProvider: SuggestionProvider = {
  type: "variableArguments",
  search: (_str, doc) => {
    const { selectedNodes, isMathOnlySelection } = doc.selection;

    if (!isMathOnlySelection) {
      return [];
    }

    const [first, second] = selectedNodes;

    if (selectedNodes.length === 1 && first?.is(VariableNodeModel) && first.hasParams) {
      const splitArguments: SingleSuggestion = {
        type: "single",
        item: {
          type: "variable",
          intlName: "splitArguments",
          symbol: "",
        },
        action: {
          type: "split-arguments",
          nodeId: first.id,
        },
        keywords: normalizeSuggestionKeywords({ keywords: ["split", "arguments", "detach"] }),
        icon: "math/DetachArgument",
        forceIcon: true,
        popupGroup: "variableArguments",
        priority: 1,
      };

      return [[splitArguments]];
    }

    if (
      selectedNodes.length === 2 &&
      first?.is(VariableNodeModel) &&
      !first.hasParams &&
      second?.is(GroupNodeModel)
    ) {
      const applyToVariable: SingleSuggestion = {
        type: "single",
        item: {
          type: "variable",
          intlName: "applyToVariable",
          symbol: "",
        },
        action: {
          type: "merge-group-into-variable",
          nodeId: first.id,
          groupId: second.id,
        },
        keywords: normalizeSuggestionKeywords({ keywords: ["apply", "arguments", "function"] }),
        icon: "math/MergeArgument",
        forceIcon: true,
        popupGroup: "variableArguments",
        priority: 1,
      };

      return [[applyToVariable]];
    }

    return [];
  },
};
